import React from 'react';
import PageShell from './PageShell';
import Breadcrumbs from '../Breadcrumbs';
import FAQ from '../sections/FAQ';
import MidCTA from '../sections/MidCTA';
import { usePageMeta } from '../../lib/useMeta';

const PATH = '/faq';

const BREADCRUMBS = [
  { label: 'Home', href: '/' },
  { label: 'FAQ' },
];

const FaqPage = () => {
  usePageMeta({
    title: 'Karate FAQ for Parents & New Students | Universal Kempo Karate',
    description:
      'Common questions about our Colorado Springs karate program \u2014 ages, pricing, free trial, uniforms, class schedule, belt progression, parking, and more.',
    path: PATH,
    breadcrumbs: BREADCRUMBS,
  });
  return (
    <PageShell>
      <Breadcrumbs items={BREADCRUMBS} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-6 pb-4">
        <h1 className="font-display font-black tracking-tight text-white text-[2rem] leading-[1.05] sm:text-5xl sm:leading-[1.02]">
          Karate FAQ
        </h1>
        <p className="mt-4 text-white/75 text-[15px] sm:text-lg leading-relaxed max-w-3xl">
          Everything parents and new students ask before their first class — answered honestly,
          no sales pressure.
        </p>
      </div>
      <FAQ />
      <MidCTA />
    </PageShell>
  );
};

export default FaqPage;
